import React from "react";
import { useQuery, } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//Team BdmScoreboard
import BdmScoreboard from "components/sports/bdm/views/BdmScoreboard";
//Team Statistics
import BdmTeamStats from 'components/sports/bdm/views/BdmTeamStats'
//Players Statistics
import BdmPlayerStats from "components/sports/bdm/views/BdmPlayerStats";
import Referees from 'components/general/Referees'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import { isStartListStatus } from "helpers/status";

const BdmContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <div >No data available</div>; }
    if (isLoading) { return <Loader />; }

    //console.log(data)

    const filtersQualRule = {
        ei_type: ['UI'],
        ei_code: ['QUAL_RULE']
    };

    const resultStatus = data?.results?.status?.code;
    let bodyMiddle
    let score

    if (data?.results) {
        bodyMiddle = <BdmScoreboard data={data} status={resultStatus} mirs_discipline={mirs_discipline} />
    }
    let location = data?.results?.schedule?.location?.shortDescription;
    let round = data?.results?.eventUnit?.shortDescription;
    score = <ScoreHorizontal
        data={data}
        scoreHeader={{
            left: <>{round} - {location}</>
        }}
        scoreBody={{
            top: <></>,
            middle: <>{bodyMiddle}</>
        }}
    />

    return (
        <>
            <div className='mirs-page-container'>
            {data?.results ? (
                <>
                    <PageHeader data={data} />
                    {/* <div className='my-5'>*/}
                    {score}
                    {/*</div>*/}

                    {data?.results?.officials &&
                        <Referees data={data?.results?.officials} />
                    }

                    {!isStartListStatus(resultStatus) &&
                    /*{ Match / Games Statistics }
                    { Player Statistics }*/
                    <>

                        <BdmPlayerStats data={data} />
                    </>
                    }
                </>
            ) : (
                <NotAvailable />
            )
            }
            </div>
        </>
    )

}

export default BdmContext;